export default {
	data() {
		return {
			table: {
				pagesize: 100,
				currentPage: 1,
				head: [],
				data: [],
				tmepData: [],
				rowid: '_column_id',
				_height: undefined
			},
			FunBtnList: {},
			tableType: 'seq',
			DoSaveLoad: false,
			DoDeleteLoad: false,
			loading:false
		}
	},
	// computed: {

	// },
	methods: {
		tableChangeData(data){
			console.log(data)
			let {row,index,column}=data;
			let rowOrigin=this.table.data[index];
			let tempRow=this.table.tmepData[index];
			if(String(rowOrigin[column.property])!=String(tempRow[column.property])){
				this.table.tmepData[index][column.property]=rowOrigin[column.property];
				this.table.tmepData[index]['_hasChange']=1;
			}
		},
		tableRowStyle({row, rowIndex}) {
			// console.log('Test',row['背景颜色'])
			let StyleStr={};
			if(row['背景颜色']){
				let backColor=this.GetColor(row['背景颜色'])
				StyleStr['background']=backColor;
				// background
				// StyleStr+=$`backgroud-color:${backColor};`;
			}
			
			if(row['字体颜色']){
				let textColor=this.GetColor(row['字体颜色']);
				StyleStr['color']=textColor;
				// StyleStr+=$`backgroud-color:${textColor};`;
			}
			// console.log(row['字体颜色'])
			// console.log(StyleStr)
			return StyleStr;
		},
		tableRowClass({row, rowIndex}) {
			if(row['背景颜色']){
				let backColor=this.GetColor(row['背景颜色'])
				if(backColor!=''){
					return 'frmReport_tableRow frmReport_tableRow_back'
				}
			}
			return 'frmReport_tableRow';
		},
		select() {
			try {
				this.selectLog = true;
				this.$BH().base.http({
					url: 'Web/getReportData',
					data: {
						Filter: [this.filterForm],
						strFunc: this.pageId,
						FUser: this.userinfo.pfnumber,
						gysFUser: this.userinfo.fnumber,
						FType: this.userinfo.accountType,
					},
					success: (response) => {
						// let {
						// 	reportFilter
						// } = response.data.value;
						this.table.data = response.data.value;
						this.table.tmepData = JSON.parse(JSON.stringify(response.data.value));
						this.table.currentPage = 1;
						if (this.$refs.table)
							this.$refs.table.checkColumnChange();
					},
					loadingcontrol: () => {
						this.selectLog = false;
					}
				})
			} catch (e) {
				//TODO handle the exception
				this.$BH().message(e)
			}
		
		},
		DoRequest(dotype, doarr) {
			this.$BH().base.http({
				url: 'Web/reportDoFn',
				data: {
					FUser: this.userinfo.pfnumber,
					gysFUser: this.userinfo.fnumber,
					FType: this.userinfo.accountType,
					doarr: doarr,
					FDotype: dotype == '保存' ? 'save' : 'delete',
					strFunc: this.pageId,
				},
				success: (res) => {
					this.$BH().message(`${dotype}成功！`);
					this.table.tmepData = JSON.parse(JSON.stringify(this.table.data));
				},
				loadingcontrol: () => {
					this.DoSaveLoad = false;
					this.DoDeleteLoad = false;
				}
			})
		},
		DoSaveChangeBtn() {
			try {
				let doarr = this.CheckDo('保存');
				this.$BH().confirm('是否确定保存当前数据？', (e) => {
					if (e == 'confirm') {
						if (this.DoSaveLoad) return;
						this.DoSaveLoad = true;
						this.DoRequest('保存', doarr);
					}
				});
			} catch (e) {
				//TODO handle the exception
				this.$BH().message(e);
				this.DoSaveLoad = false;
			}
		},
		SelectColumns(columns) {
			//如果有操作按钮，且如果有其他的修改列的化，那么就需要更改当前表格的属性
			//搜索是否存在选择列
			columns = columns || [];
			let selectIndex = columns.findIndex(item => {
				return item.name == '选择' && item.edit;
			});
			if (selectIndex > -1) {
				//判断是否存在多个修改属性
				let edicolumns = columns.filter(item => item.edit);
				if (edicolumns.length > 1) {
					this.tableType = 'checkbox';
					columns[selectIndex].hide = true;
				} else {
					this.tableType = 'seq';
				}
			} else this.tableType = 'seq';
			return columns.filter(item=>!['_id','_fid'].includes(item.name));
		},
		initPage() {
			try {
				this.pageLoad = true;
				this.$BH().base.http({
					url: 'Web/getReportInit',
					data: {
						strFunc: this.pageId,
						strPage: this.menuId,
						FFormName: "frmReport",
						FUser: this.userinfo.pfnumber,
						gysFUser: this.userinfo.fnumber,
						FType: this.userinfo.accountType,
					},
					success: (response) => {
						let {
							reportFilter,
							columns,
							FuncSetes
						} = response.data.value;
						this.FunBtnList = (FuncSetes && FuncSetes[0]) || {};
						this.table.head = this.SelectColumns(columns);
						
						this.$nextTick(() => {
							this.$refs.table && this.$refs.table.checkColumnChange();
						})
						let filterarr;
						if (reportFilter && reportFilter.length > 0) filterarr = reportFilter;
						// else filterarr = columns;
						//列名 数据类型
						let tempFilter = []
						for (let i in filterarr) {
							let name = '标题';
							let currentobj = {};
							currentobj['Display'] = filterarr[i][name];
							currentobj['name'] = filterarr[i]['关键字'];
							// currentobj['name']=currentobj['name'].replaceAll('#','')
							if (filterarr[i]['数据类型'].includes('varchar') || filterarr[i]['数据类型']
								.includes(
									'String') || filterarr[i]['数据类型'].includes('文本')) {
								currentobj['dataType'] = 'text'
								currentobj['type'] = 1;
							} else if (filterarr[i]['数据类型'].includes('datetime') || filterarr[i]['数据类型']
								.includes(
									'DateTime') || filterarr[i]['数据类型'].includes('日期')) {
								currentobj['dataType'] = '日期';
								currentobj['type'] = 3;
							} else if (filterarr[i]['数据类型'].includes('bit') || filterarr[i]['数据类型']
								.includes(
									'Bool') || filterarr[i]['数据类型'].includes('真假')) {
								currentobj['type'] = 4;
							} else if (filterarr[i]['数据类型'].includes('数量')) {
								currentobj['dataType'] = 'number'
								currentobj['type'] = 1;
							}
							//包含下拉字段的内容
							if(Object.prototype.hasOwnProperty.call(response.data.value,currentobj['name'])){
								currentobj['type'] = 2;
								currentobj['dataSource'] = response.data.value[currentobj['name']]||[];
								currentobj['valueName'] = filterarr[i]['FInputValueCol'];
								currentobj['displayName'] = filterarr[i]['FInputDisplayCol'];
							}
							if (currentobj['type'])
								tempFilter.push(currentobj);
							this.filterForm[currentobj['name']] = filterarr[i]['FDefaultValue']||''
						}
						// console.log(tempFilter)
						// let filter_a = tempFilter.map(item => {
						// 	return {
						// 		key: item['name'],
						// 		name: item['Display'],
						// 		DataType: item['dataType']
						// 	}
						// })
						// this.filterList_a = Filter.makeArr(...filter_a);
						// this.table.head = columns;
						this.filterList = tempFilter;
						console.log(this.filterList,this.filterForm)
						this.filterForm=JSON.parse(JSON.stringify(this.filterForm))
						// this.$forceUpdate()
					},
					loadingcontrol: () => {
						this.pageLoad = false;
					}
				})
			} catch (e) {
				this.$BH().message(e);
			}
		}

	}
}